/* eslint-disable arrow-body-style */
import { AxiosError, AxiosResponse } from 'axios';
import { IdNameModel } from '../store/listing-options/ListingOptionsModels';
import SnackbarUtil from '../utils/SnackbarUtil';
import { axiosInstance } from '../utils/axiosConfig';

const EVENT_TYPES_URL = '/api/event-types';
const OBJECT_TYPES_URL = '/api/object-types';
const OBJECT_CHARACTERISTICS_URL = '/api/object-characteristics';
const OFFER_FEATURES_URL = '/api/offer-features';
const DELETE_LISTING_IMAGE = '/api/delete-listing-image';

export const getEventTypesAdapter = (): Promise<IdNameModel[]> => {
  return axiosInstance
    .get(EVENT_TYPES_URL)
    .then((response: AxiosResponse<IdNameModel[]>): IdNameModel[] => response.data)
    .catch((error: AxiosError): IdNameModel[] => {
      SnackbarUtil.error(error.message);
      return [];
    });
};

export const getObjectTypesAdapter = (): Promise<IdNameModel[]> => {
  return axiosInstance
    .get(OBJECT_TYPES_URL)
    .then((response: AxiosResponse<IdNameModel[]>): IdNameModel[] => response.data)
    .catch((error: AxiosError): IdNameModel[] => {
      SnackbarUtil.error(error.message);
      return [];
    });
};

export const getObjectCharacteristicsAdapter = (): Promise<IdNameModel[]> => {
  return axiosInstance
    .get(OBJECT_CHARACTERISTICS_URL)
    .then((response: AxiosResponse<IdNameModel[]>): IdNameModel[] => response.data)
    .catch((error: AxiosError): IdNameModel[] => {
      SnackbarUtil.error(error.message);
      return [];
    });
};

export const getOfferFeaturesAdapter = (): Promise<IdNameModel[]> => {
  return axiosInstance
    .get(OFFER_FEATURES_URL)
    .then((response: AxiosResponse<IdNameModel[]>): IdNameModel[] => response.data)
    .catch((error: AxiosError): IdNameModel[] => {
      SnackbarUtil.error(error.message);
      return [];
    });
};

export const deleteListingImageAdapter = (id: number, image: string): Promise<string | undefined> => {
  return axiosInstance
    .patch(`${DELETE_LISTING_IMAGE}/${id}`, { image: image })
    .then((response: AxiosResponse<string>): string => {
      SnackbarUtil.success('Slika uspješno pobrisana');
      return response.data;
    })
    .catch((error: AxiosError): undefined => {
      console.log(error);
      // @ts-ignore
      SnackbarUtil.error(error.response.data.message);
      return undefined;
    });
};
